import request from '@/utils/request'
export default {
  // 下面这个接口,是开发状态下清楚所有数据的接口,生产环境需要注释掉
  clearAll (data) {
    let dt = data || {}
    return request.post('/management/deletemyprogress', dt.params, {
      headers: dt.headers || {}
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/clearAll.js


// WEBPACK FOOTER //
// ./src/api/clearAll.js